import React, {FunctionComponent} from "react";
import {ArticleImage} from "../articleImage";
import {ArticleView} from "../articleView";
import {trimString} from "@klear/open-site/interfaces";

const  styles = require('./articleLong.component.scss');

const articleLongExcerptLength = 150;

interface ArticleLongProps {
    mainArticleImage: string,
    date?: string,
    mainArticleTitle: string,
    mainArticleDescription: string,
}

export const ArticleLong: FunctionComponent<ArticleLongProps> = ({ mainArticleImage,mainArticleTitle, mainArticleDescription, date}) => {
  return (
    <>
      <div className={styles.container}>
          <div className={styles.articleText}>
              <ArticleView articleTitle={mainArticleTitle}
                           articleDescription={trimString(mainArticleDescription,articleLongExcerptLength)}
                           animation={false} date={date}/>
          </div>
          <div className={styles.articleImage}>
              <ArticleImage size={"small"} image={mainArticleImage}/>
          </div>
          <div className={styles.gotToArticleCont}>
              <div className={styles.gotToArticle}>
                  <div className={styles.goToIcon}>
                      <i className='fa fa-arrow-right'/>
                  </div>
                  <div>
                      Go to Article
                  </div>
              </div>
          </div>
      </div>
    </>
  )
}
